import { UserProfileStatusBubble } from 'components/shared/UserProfileStatusBubble';
import { SimpleTextCell } from 'components/Table/Cells/SimpleTextCell';
import { Column } from 'react-table';
import { UserProfile } from 'types';

export function createTableColumns(): Column<UserProfile>[] {
  return [
    {
      Header: 'Name',
      accessor: 'fullName',
      Cell: ({ original }: { original: UserProfile }) => <SimpleTextCell value={original.fullName} />,
    },
    {
      Header: 'Title',
      accessor: 'title',
      Cell: ({ original }: { original: UserProfile }) => <SimpleTextCell value={original.title} />,
    },
    {
      Header: 'Status',
      accessor: 'status',
      Cell: ({ original }: { original: UserProfile }) => <UserProfileStatusBubble status={original.status} />,
    },
    {
      Header: 'Email',
      accessor: 'email',
      Cell: ({ original }: { original: UserProfile }) => <SimpleTextCell value={original.email} />,
    },
    {
      Header: 'Phone',
      accessor: 'phoneNumber',
      Cell: ({ original }: { original: UserProfile }) => <SimpleTextCell value={original.phoneNumber} />,
    },
  ].map(header => ({
    ...header,
    resizable: false,
    headerClassName: 'customHeader',
  }));
}
